import { render } from "./MaintenanceOSTiposTab.vue?vue&type=template&id=2a39191c&scoped=true&ts=true"
import script from "./MaintenanceOSTiposTab.vue?vue&type=script&lang=ts"
export * from "./MaintenanceOSTiposTab.vue?vue&type=script&lang=ts"

import "./MaintenanceOSTiposTab.vue?vue&type=style&index=0&id=2a39191c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a39191c"]])

export default __exports__